module.exports = __webpack_public_path__ + "media/images/pc/special_plans/separator_suns-8254e66085f8d41285a40ff8fe17501a.png";